module.exports = __webpack_public_path__ + "static/media/normal-window.2197377e.png";